<template>
  <div class="list-panel">
    <div class="main-container">
      <div class="tab-con">
        <el-menu  :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
          <el-menu-item index="list">品牌列表</el-menu-item>
		  <el-menu-item index="list2">创建品牌</el-menu-item>
        </el-menu>
      </div>
      <div class="content-wrap">
			<List v-if="activeIndex == 'list'" ></List>
			<Add :restId='restId' v-else-if="activeIndex == 'list2'"></Add>
      </div>
    </div>
  </div>
</template>

<script>
import List from './list.vue';
import Add from './add.vue';
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      activeIndex: "list",
      queryData: {},
	  restId:null,
    };
  },
  components: {
	List,
	Add,
  },
  computed: {
    ...mapGetters(["permissions", "dicts"]),
  },
  methods: {
    handleSelect(key, keyPath) {
		console.log(key, keyPath)
      this.activeIndex = key;
	  this.restId = null
    },
    dealToContractList() {
      this.activeIndex = "list";
    },
  },
};
</script>